import { isExcludedBot } from './botBlock';

export function identify(customerInfo) {
  if (isExcludedBot) return;
  if (window?.analytics?.identify) {
    window.analytics.identify(customerInfo);
  }
}

export function track(title, dataObject, ctx = {}) {
  if (isExcludedBot) return;
  if (window?.analytics?.track) {
    let id;
    try {
      id = window.localStorage.getItem('clickid');
    } catch {
      id = null;
    }

    const context = {
      context: {
        ...ctx,
        ...(id && {
          referrer: {
            type: 'impactRadius',
            id,
          },
        }),
      },
    };

    window.analytics.track(title, dataObject, context);
  }
}
